import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NeqHeaderValues } from '@sharedcommon/model/header-values.model';

@Injectable()
export class HeaderService {

    private headerTitleSource = new Subject<NeqHeaderValues>();

    public valuesLoaded = true;

    headerTitle$ = this.headerTitleSource.asObservable();

    setHeaderValues(headerValues: NeqHeaderValues) {
        this.headerTitleSource.next(headerValues);
    }

}
